import $ from 'jquery';
import checkSupport from './check-support';

var headerHeight = 70;

var smoothScrollTo = function (target) {
  if (!target) target = 'body';

  if ($(target).length) {
    var hasNativeScroll = checkSupport.supportsSmoothScroll();
    let destination = Math.round($(target).offset().top - headerHeight);

    if (hasNativeScroll) {
      // barely supported but looks the best
      window.scroll({ top: destination, behavior: 'smooth' });
    } else {
      // javascript fallback
      jsScrollTo(destination);
    }
  }
};

window.jsScrollTo = (function () {
  // https://codereview.stackexchange.com/questions/13111/smooth-page-scrolling-in-javascript
  var timer, start, factor;

  return function (target, duration) {
    var offset = window.pageYOffset;
    var delta = target - window.pageYOffset; // Y-offset difference
    var duration = duration || 250; // default animation
    var start = Date.now(); // get start time
    var factor = 0;

    if (timer) {
      clearInterval(timer); // stop any running animations
    }

    function step() {
      var y;
      factor = (Date.now() - start) / duration; // get interpolation factor
      if (factor >= 1) {
        clearInterval(timer); // stop animation
        factor = 1; // clip to max 1.0
      }
      y = factor * delta + offset;
      window.scrollBy(0, y - window.pageYOffset);
    }

    timer = setInterval(step, 10);
    return timer;
  };
})();

export default { smoothScrollTo };
